module.exports = __webpack_public_path__ + "img/bg_vocabulary_03.2cfc6b12.jpg";